// Создание ошибки последним элементом внутри формы
// первым аргументом может передаваться либо селектор, либо сама форма по имени
// createError(document.forms.order, 'Блин блинский...')
// createError('#contact-1', 'Блин, засада!')
//

// Активация загрузки кнопки формы по сабмиту
// turnIntoLoader(e) запускается по сабмиту формы
// turnIntoButton(button) принимает аргументом либо саму кнопку,
// либо селектор кнопки, для которой надо прекратить лоадер

import axios from "axios";
import {turnIntoLoader, turnIntoButton, openTheModal} from "../functions";

let data

document.querySelectorAll('.contact__form, .request-popup__form, .discount-popup__form').forEach((form) => {
    form.addEventListener("submit", (e) => {
        e.preventDefault();

        removeError(".err");

        turnIntoLoader(e.submitter);

        data = Object.fromEntries(new FormData(e.target));

        const phoneInput = window.intlTelInputGlobals.getInstance(
            e.target.querySelector('[type="tel"]')
        );

        data.phone = data.phone
            ? `+${phoneInput.getSelectedCountryData().dialCode} ${data.phone}`
            : "";

        if (phoneInput.getValidationError() === 2) {
            createError(e.target, "Слишком короткий номер");
            turnIntoButton(e.submitter);
            return;
        }

        const keys = ['utm_source', 'utm_campaign', 'utm_medium', 'amoid'];

        keys.forEach(key => {
            const value = localStorage.getItem(key);
            if (value) {
                const camelKey = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
                data[camelKey] = value;
            }
        });


        const params = new URLSearchParams(window.location.search);
        const finishDemoParam = params.has("finish-demo");
        if (finishDemoParam) {
            data['finish_demo'] = finishDemoParam;
        }

        const leadData = JSON.stringify(data)
        sessionStorage.setItem('leadData', leadData);

        const res = axios
            .post("/modal", data)
            .then((res) => {
                return openTheModal('[data-target="thank-without-payment"]')
                // goToPayment([
                //     {
                //         name: 'option',
                //         value: data.option
                //     },
                //     {
                //         name: 'lead_id',
                //         value: res.data
                //     },
                // ])
            })
            .catch((err) => {
                for (const [key, value] of Object.entries(
                    err.response.data.errors
                )) {
                    createError(e.target, value);
                }
            })
            .finally(() => {
                turnIntoButton(e.submitter);
            });

        return false;
    });
});

function goToPayment(params) {
    const url = new URL(`${window.location.origin}/payment`)

    params.forEach(({name, value}) => {
        url.searchParams.set(name, value)
    })

    window.location.href = url.href
}

function createError(form, text) {

    let currentForm

    if (typeof form === 'string') {
        currentForm = document.querySelector(form)
    } else {
        currentForm = form
    }

    currentForm?.insertAdjacentHTML('beforeend',
        `<div class="err">
			${text}
		</div>`
    )
}

function removeError(selector) {
    const err = document.querySelectorAll(selector)
    for(const el of err)
    {
        el.remove()
    }
}
